import React, { useRef, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal
} from '@/components/ui/dialog';
import { extractNamesAndImages } from '@/lib/helpers';
import { useDispatch } from 'react-redux';
import { bulk_create_ingredients } from '@app/pages/meals/redux/reducer';

const UploadIngredientsModal = ({ isOpen, onOpenChange }) => {
  const [file, setFile] = useState(null);
  const [pack, setPack] = useState(null);
  const fileRef = useRef();
  const dispatch = useDispatch();

  const handleFile = async (file) => {
    if (!file) return;

    try {
      setFile(file);
      const results = await extractNamesAndImages(file, {
        nameColumn: 'A', // change to whichever column holds the name
        headerRow: 1 // change if your header isn't row 1
      });
      const data = results?.map((item) => {
        return {
          name: item.name,
          image: item.imageBlob
        };
      });
      setPack(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFileSelect = () => {
    fileRef.current?.click();
  };

  const handleSubmit = () => {
    dispatch(bulk_create_ingredients(pack));
    if (fileRef.current) {
      fileRef.current.value = ''; // Reset the input value
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <DialogContent
          className="
            fixed left-1/2 top-1/2 z-50
            w-full !max-w-[400px] -translate-x-1/2 -translate-y-1/2
            rounded-2xl  bg-white p-0 !border-0
            focus:outline-none
            data-[state=open]:animate-in data-[state=closed]:animate-out
            data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0
            data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95
            data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]
            data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]
          "
        >
          <div className="px-4 py-5">
            <input
              ref={fileRef}
              type="file"
              accept=".xlsx, .csv"
              onChange={(e) => handleFile(e.target.files?.[0])}
              className="hidden"
            />

            <div className="flex gap-3 items-center">
              <p className="flex-1">{file ? file?.name : 'Please select a file'}</p>
              <button
                onClick={handleFileSelect}
                className="px-4 py-2 text-sm font-medium bg-transparent rounded-lg border transition-colors border-[#003232] text-zinc-400"
              >
                Select File
              </button>
            </div>

            <button onClick={handleSubmit}>Save</button>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default UploadIngredientsModal;
